import { isNonNullish, sortAlphabetically } from '@root/helpers';
import type { Table } from '@tanstack/react-table';

export const getColumnFilterOptions = (table: Table<any>, columnId: string): string[] =>
  Array.from(
    new Set(
      table
        .getCoreRowModel()
        .flatRows.map((row) => row.getValue(columnId))
        .filter((item) => isNonNullish(item) && (item as string)?.trim()) as string[],
    ),
  ).sort(sortAlphabetically);
